module.exports = __webpack_public_path__ + "static/media/gal-flag.44198a0a.png";